import { ClientController, BlastworksClientEvent } from 'client-controller';
import { PYLPressYourLuckBonusState } from 'states/pyl-press-your-luck-bonus-state';

/**
 * Social bonus state to send client messages
 *
 * @class SocialPressYourLuckBonusState
 * @typedef {SocialPressYourLuckBonusState}
 * @extends {PYLPressYourLuckBonusState}
 */
export class SocialPressYourLuckBonusState extends PYLPressYourLuckBonusState {
  /**
   * Send bonus start message
   *
   * @public
   * @override
   * @param {?boolean} [cascadeSkip]
   */
  public onEnter(cascadeSkip?: boolean): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_START);
    super.onEnter(cascadeSkip);
  }

  /**
   * Send bonus complete message
   *
   * @public
   * @override
   */
  public onExit() {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_COMPLETE);
    super.onExit();
  }
}
